const formTranslation = {
  'form.search': 'Search',
  'form.name': 'Name',
  'form.email': 'Email',
  'form.confirmEmail': 'Confirm Email',
  'form.language': 'Language',
  'form.language.en-US': 'English (US)',
  'form.language.pt-BR': 'Portuguese (BR)',
  'form.password': 'Password',
  'form.confirmPassword': 'Confirm Password',
  'form.type.natural': 'Natural Person',
  'form.type.legal': 'Legal Person',
  'form.businessName': 'Business Name',
  'form.gender': 'Gender',
  'form.gender.male': 'Male',
  'form.gender.female': 'Female',
  'form.gender.other': 'Other',
  'form.birthdate': 'Birth of Date',
  'form.photo': 'Photo',
  'form.phone': 'Phone',
  'form.businessPhone': 'Business Phone',
  'form.country': 'Country',
  'form.state': 'State',
  'form.city': 'City',
  'form.zipcode': 'Zipcode',
  'form.street': 'Address',
  'form.submit.button': 'Submit',
  'form.save.button': 'Save',
  'form.login.subtitle': 'Access your account',
  'form.login.button': 'Sign In',
  'form.register.button': 'Sign Up',
  'form.cancel.button': 'Cancel',
  'form.seeAll.button': 'See All',
  'form.next.button': 'Next',
  'form.prev.button': 'Previous',
  'form.goback.button': 'Go Back',
  'form.select.placeholder': 'Select...',
};

export default formTranslation;
